import ApiService from "@/services/Api"

import {
	CreateReferralPayload,
	CreateReferralResponse,
	ReferralWalletData
} from "@/pages/Attendance/ReferralPopup/types"

class ReferralService {
	async createReferral (payload: CreateReferralPayload): Promise<CreateReferralResponse> {
		const { data } = await ApiService.post<CreateReferralResponse>("/referral", payload)

		return data
	}

	async getWallet (): Promise<ReferralWalletData> {
		const { data } = await ApiService.get<ReferralWalletData>("/referral/wallet")

		return data
	}

	async getIndicationLink (): Promise<{ link: string }> {
		const { data } = await ApiService.get<{ link: string }>("/referral/link")

		return data
	}
}

export default new ReferralService()
